import { MeasureFormatter } from '@principle-theorem/principle-core/interfaces';

export interface ICustomReportFilterFormatter {
  formatter?: MeasureFormatter;
  prefix?: string;
  suffix?: string;
}

export interface ICustomReportFilterSummary {
  label: string;
  isArray: boolean;
  comparison: string;
  value: string;
}
